import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

function normalizeSaasListQueryParams(arg) {
  const raw = arg == null || typeof arg !== "object" || Array.isArray(arg) ? {} : arg;
  return Object.fromEntries(
    Object.entries(raw).filter(([, v]) => v != null && String(v).trim() !== "")
  );
}

export const fetchSaasBillingList = createAsyncThunk(
  "saasBilling/fetchList",
  async (queryParams = {}, { rejectWithValue }) => {
    try {
      const params = normalizeSaasListQueryParams(queryParams);
      const response = await get(API_ENDPOINTS.BILLING.SAAS_MODULE, params);
      const raw = response.data;
      return raw?.data?.list || raw?.list || [];
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch SaaS module billing"));
    }
  }
);
